import {AManagerApi} from "@/classes/app/api/manager/a-manager-api";

export default class OwnerCouponTicket extends AManagerApi {
    protected _url: string = '/owner/coupon/ticket';
}
